module.exports = __webpack_public_path__ + "static/media/04.b43767c9.png";